export const getGtmPageType = (pageType) => {
    const pageId = generateTenDigitNumber();

    if (pageType === 'home') {
        return {
            type: 'homepage',
            id: pageId,
        };
    } else if (pageType === 'collection') {
        return {
            type: 'category',
            id: pageId,
        };
    } else if (pageType === 'product') {
        return {
            type: 'product',
            id: pageId,
        };
    } else if (pageType === 'cart') {
        return {
            type: 'cart',
            id: pageId,
        };
    } else if (pageType === undefined) {
        return {
            type: '404',
            id: pageId,
        };
    } else if (pageType === 'searchresults') {
        return {
            type: 'search results',
            id: pageId,
        };
    } else {
        return {
            type: 'other',
            id: pageId,
        };
    }
};

const generateTenDigitNumber = () => {
    const randomTenDigitNumber = Math.floor(1000000000 + Math.random() * 9000000000);
    return randomTenDigitNumber;
};
